import { act, SetStateAction, useState } from 'react';
import { Link, useLocation, useOutletContext } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { AuthContext } from './AuthWrapper';
import { Button } from './UiComponents/button';
import { Link45deg } from 'react-bootstrap-icons';
import { GetLocalFrontendBaseUrl } from '../helpers/stringHelpers';
import toast from 'react-hot-toast';

interface SidebarProps {
  waitingAmount: number;
}

export function Sidebar({waitingAmount}: SidebarProps): JSX.Element {
  const location = useLocation();

  const [isOpen, setIsOpen] = useState(false);
  const { state }: AuthContext = useOutletContext();
  const [activeItem, setActiveItem] = useState<string>(location.pathname.split('/')[2].toLowerCase() || '');

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
    // Only add/remove overflow-hidden when sidebar is opened
    if (!isOpen) {
      document.body.classList.add('overflow-hidden');
    } else {
      document.body.classList.remove('overflow-hidden');
    }
  };
  const handleItemClick = (item: SetStateAction<string>) => {
    setActiveItem(item);
  };
  const closeSidebar = () => {
    setIsOpen(false);
    document.body.classList.remove('overflow-hidden');
  };

  return (

    <>
      {state.user?.admin &&
        <>
        <Button
          className="fixed top-25 left-4 z-50 text-white md:hidden absolute"
          variant="ghost"
          onClick={toggleSidebar}
          abbr={isOpen ? "Close menu sidebar" : "Open menu sidebar"}
        >
          {isOpen ? <X size={24} /> : <Menu className='text-black dark:text-white' size={24} />}
        </Button>

        <div
          className={`fixed top-17 left-0 z-40 bg-[#006747] w-full min-h-full p-4 text-white transition-transform duration-300 ${isOpen ? 'translate-x-0 overflow-y-auto' : '-translate-x-full overflow-hidden'
            } md:relative md:translate-x-0 md:w-[250px] md:min-h-full md:flex md:flex-col md:space-y-4`}
        >
          <h1 className="text-xl font-bold mb-4 md:text-2xl md: mt-10">Welcome, {state.user?.firstName}!</h1>
          <nav className="space-y-2 md:space-y-3 flex flex-col">
            <Link className={`text-white text-lg ${
                activeItem === "dashboard" && "font-bold "
              }`} to="dashboard" onClick={() => { closeSidebar(); handleItemClick("dashboard"); }}>
              Dashboard
            </Link>
            <Link className={`text-white text-lg ${
                activeItem === "awardsprograms" && "font-bold "
              }`} to="awardsprograms" onClick={() => { closeSidebar(); handleItemClick("awardsprograms"); }}>
              Awards/Programs
            </Link>
            <Link className={`text-white text-lg ${
                activeItem === "staff" && "font-bold "
              }`} to="staff" onClick={() => { closeSidebar(); handleItemClick("staff"); }}>
              Manage Staff
            </Link>
            <div className='inline-flex space-x-2 items-center'>
              <Link className={`text-white text-lg ${
                  activeItem === "waitingroom" && "font-bold"
                }`} to="waitingRoom" onClick={() => { closeSidebar(); handleItemClick("waitingroom"); }}>
                  Waiting Room
              {waitingAmount > 0 && <span className='inline-flex items-center justify-center h-5 max-w-6 mt-1 px-4 ml-2 bg-red-500 rounded-full text-sm font-semibold'>
                {waitingAmount > 9 ? "9+" : waitingAmount}
              </span>}
              </Link>
              {activeItem != 'waitingroom' ? <Button
                variant="ghost"
                size="sm"
                type="button"
                className='px-0'
                abbr='Click to copy link for student check-in'
                onClick={() => {
                  navigator.clipboard.writeText(`${GetLocalFrontendBaseUrl()}/checkin`);
                  toast.success("Copied link to clipboard!")
                }}
                >
                <Link45deg className='w-5 h-5'/>
              </Button> : <></>}
            </div>

          </nav>
        </div>
      </>}
    </>
  );
};
